import { useEffect, useState, useContext } from "react";
import { BrowserRouter, Route, Switch, useParams } from "react-router-dom";

import useToken from "../../hooks/useToken";
import { DataContext, DataProvier } from "./data/DataContext";
import { siteTitle, lstPageTitle, inspectionStatusEnum, typeFileEnum, stepEnum } from './data/MochaData';
import { LineProgressBar, PagesTitleCtrl, ButtonCtrl, ModalMsgCtrl } from './components'
import Modal from 'react-modal'
import { IconError } from './img'

import './Reclamos_Inspeccion.css'
import { InitPage, TotalPageBar } from "./data/Data";
import {
    buildDataUpdate,
    compressFiles, getFilesInspection,
    getVehicleDamageNIDTO,
    buildDataVehicleInvolved,
    getNewGuid,
    nameFile
} from './data/Help';
import { Pages } from './pages/Pages';
import http from "../../services/http";
import { endPoints } from "../../utils/constanst";
import { useModal } from './hook'
import { validateToken } from '../../services/validate'

const Reclamos_Inspeccion = () => {

    const { loading } = useToken();

    useEffect(() => {
        if (!loading) {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }
    }, [loading]);

    if (loading) return (<></>);
    return (
        <DataProvier loading={loading} >
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/ni/reclamos_inspeccion/:id" component={Layout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );

}

const Layout = ({ location }: IPropsParam) => {

    const loadingModal = useModal({ isloading: true, txtMsg: 'Validando registro...', active: true } as IModalProps);
    const msgModal = useModal({ isloading: false, txtMsg: '', active: false, hideCloseModal: false } as IModalProps);
    const [infoPage, setInfoPage] = useState(lstPageTitle.find(x => x.index === InitPage) as IPageInfo);
    const [index, setIndex] = useState(InitPage);
    const { ReclamosInspeccionNI, setReclamosInspeccionNI } = useContext(DataContext);
    let options = { enableHighAccuracy: true, timeout: 5000, maximumAge: 0, };
    const [modalErrorId, setModalErrorId] = useState(false);

    const { id } = useParams<any>();
    const { login } = useToken();

    useEffect(() => {      
        GetInformationInspection();
    }, [])

    useEffect(() => {
        GetCurrentLocation();
    }, [ReclamosInspeccionNI.id])

    useEffect(() => {
        window.addEventListener("beforeunload", ReloadPage);
        return () => { window.removeEventListener("beforeunload", ReloadPage); };
    });

    const Decrement = () => {
        let pageInfo = lstPageTitle.find(x => x.index === index - 1);
        setInfoPage(pageInfo ?? {} as IPageInfo);
        setIndex(index - 1);
    }

    const Increment = () => {
        let pageInfo = lstPageTitle.find(x => x.index === index + 1);
        setInfoPage(pageInfo ?? {} as IPageInfo);
        setIndex(index + 1);
    }


    const Submit = async () => {
        let result = document.querySelector("form") as HTMLFormElement;

        if (result.reportValidity() === false)
            return;
        if(ReclamosInspeccionNI.id === 0)
        {
            setModalErrorId(true);
            return;
        }
    

        loadingModal.show('Guardando los datos...');

        //console.log(login());
        if (validateToken() === false)
            await login();

        switch (index) {
            case stepEnum.step1:
                saveStep1()
                break;
            case stepEnum.step2:
                GetInfoEnte();
                break;
            case stepEnum.step3:
                saveStep3();
                break;
            case stepEnum.step4:
                saveStep4();
                break;
            case stepEnum.step5:
                saveStep5();
                break;
            case stepEnum.step6:
                saveStep6();
                break;
            default:
                loadingModal.hide();
                Increment();
        }


    }

    const saveStep1 = () => {
        UpdateInspection(ReclamosInspeccionNI.registration === 'N' ? inspectionStatusEnum.cancelled : inspectionStatusEnum.process)
            .then(x => {
                if (ReclamosInspeccionNI.registration === 'S') {
                    loadingModal.hide();
                    Increment()
                } else window.location.reload();
            }).catch(() => loadingModal.hide())
    }

    const saveStep3 = () => {
        Promise.allSettled([
            UpdateInspection(inspectionStatusEnum.process),
            UploadFile('identificationFrontImageIsModified', ReclamosInspeccionNI.identificationFrontImage, typeFileEnum.identificationFrontImage),
            UploadFile('identificationBackImageIsModified', ReclamosInspeccionNI.identificationBackImage, typeFileEnum.identificationBackImage),
            UploadFile('driverLicenseImageIsModified', ReclamosInspeccionNI.driverLicenseImage, typeFileEnum.driverLicenseImage)
        ]).then(x => {
            let result = x.filter(res => res.status === 'rejected');
            if (result.length > 0) {
                loadingModal.hide();
                msgModal.show('Error al actualizar los datos, intentar nuevamente');
            } else {
                setReclamosInspeccionNI({ ...ReclamosInspeccionNI, identificationFrontImageIsModified: false, identificationBackImageIsModified: false, driverLicenseImageIsModified: false })
                loadingModal.hide();
                Increment();
            }
        }).catch(() => {
            loadingModal.hide();
            msgModal.show('Ocurrio un error, comunicarse con Seguros LAFISE')
        })
    }

    const saveStep4 = () => {
        Promise.allSettled([
            UpdateInspection(inspectionStatusEnum.process),
            SaveDamage(),
            UploadFileInspectionImage(),
            UploadFile('sinisterEnvironmentImageIsModified', ReclamosInspeccionNI.sinisterEnvironmentImage, typeFileEnum.sinisterEnvironmentImage),
            UploadFile('frontVehicleImageIsModified', ReclamosInspeccionNI.frontVehicleImage, typeFileEnum.frontVehicleImage),
            UploadFile('backVehicleImageIsModified', ReclamosInspeccionNI.backVehicleImage, typeFileEnum.backVehicleImage),
            UploadFile('rightVehicleImageIsModified', ReclamosInspeccionNI.rightVehicleImage, typeFileEnum.rightVehicleImage),
            UploadFile('leftVehicleImageIsModified', ReclamosInspeccionNI.leftVehicleImage, typeFileEnum.leftVehicleImage),
            UploadFile('damageVehicleImageIsModified', ReclamosInspeccionNI.damageVehicleImage, typeFileEnum.damageVehicleImage),
        ]).then(x => {
            let result = x.filter(res => res.status === 'rejected');
            if (result.length > 0) {
                loadingModal.hide();
                msgModal.setTextError('Error al actualizar los datos, intentar nuevamente');
            } else {
                setReclamosInspeccionNI({
                    ...ReclamosInspeccionNI,
                    sinisterEnvironmentImageIsModified: false,
                    frontVehicleImageIsModified: false,
                    backVehicleImageIsModified: false,
                    rightVehicleImageIsModified: false,
                    leftVehicleImageIsModified: false,
                    damageVehicleImageIsModified: false,
                })
                loadingModal.hide();
                Increment();
            }
        })
            .catch(() => {
                loadingModal.hide();
                msgModal.show('Ocurrio un error, comunicarse con Seguros LAFISE')
            })
    }

    const saveStep5 = () => {
        Promise.allSettled([
            UpdateInspection(inspectionStatusEnum.process),
            UploadFile('imageDamageDetailIsModified', ReclamosInspeccionNI.imageDamageDetail, typeFileEnum.imageDamageDetail),
            SaveDataVehicleInvolved()
        ]).then((x) => {
            let result = x.filter(res => res.status === 'rejected');
            if (result.length > 0) {
                loadingModal.hide();
                msgModal.setText('Error al actualizar los datos, intentar nuevamente');
            } else {
                loadingModal.hide();
                Increment()
            }
        }).catch(() => {
            loadingModal.hide();
            msgModal.show('Ocurrio un error, comunicarse con Seguros LAFISE')
        })
    }
    const saveStep6 = () => {
        if (ReclamosInspeccionNI.signatureDriverIsModified === false) {
            loadingModal.hide();
            msgModal.setText('Debe guardar la firma del conductor');
            return;
        }

        let metod = [UploadFileSignatureDriver()]

        if (ReclamosInspeccionNI.signatureIsModified)
            metod.push(UploadFileSignature());

        Promise.allSettled([
            metod
        ]).then(x => {
            loadingModal.show('Creando trámite');
            Promise.allSettled([UpdateInspection(inspectionStatusEnum.finished)])
                .then((x) => {
                    let isCreated = x[0];
                    if (isCreated.status === "rejected") {
                        loadingModal.hide();
                        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, saved: false });
                        Increment();
                    }
                    else {
                        loadingModal.show('Cargando adjuntos al trámite');
                        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, saved: true, numberProcedure: isCreated.value.message });
                        Promise.allSettled([UploadFileToProcedure(), UploadFileToProcedureCheckList()])
                            .then((r) => {
                                if (r[0].status === 'fulfilled') {
                                    loadingModal.show('Enviando reporte...');
                                    http(endPoints.uploadReportInspectionToProcedure(ReclamosInspeccionNI.id)).get()
                                        .then(() => {
                                            http(endPoints.sendMailInspection(ReclamosInspeccionNI.id)).get().then(() => loadingModal.hide()).catch(() => { loadingModal.hide(); Increment(); }).finally(() => { loadingModal.hide(); Increment(); });
                                        }).catch(() => { loadingModal.hide(); Increment(); })
                                }
                                else {
                                    loadingModal.hide();
                                    Increment()
                                }
                            })//.finally(() => Increment());
                    }
                });

        }).catch(() => {
            loadingModal.hide();
            msgModal.show('Ocurrio un error, comunicarse con Seguros LAFISE')
        });
    }

    const UploadFileSignature = () => {
        let lst: Array<IImageInspectionDto> = [];
        lst.push({
            AdjuntoBase64: ReclamosInspeccionNI.signature,
            Nombre: `${nameFile[typeFileEnum.signatureImage]}.png`,
            Peso: 0,
            UltimaModificacion: new Date(),
            Usuario: '',
            Tipo: 'image/png',
        } as IImageInspectionDto);
        const data: IImageInspectionGeneral = {
            IdReclamosInspeccion: ReclamosInspeccionNI.id,
            Origen: 1,
            TipoDocumento: typeFileEnum.signatureImage,
            Archivos: lst
        } as IImageInspectionGeneral
        return http(endPoints.uploadFileInspection).post(data);
    }

    const UploadFileSignatureDriver = () => {
        let lst: Array<IImageInspectionDto> = [];
        lst.push({
            AdjuntoBase64: ReclamosInspeccionNI.signatureDriver,
            Nombre: `${nameFile[typeFileEnum.signatureDriverImage]}.png`,
            Peso: 0,
            UltimaModificacion: new Date(),
            Usuario: '',
            Tipo: 'image/png',
        } as IImageInspectionDto);
        const data: IImageInspectionGeneral = {
            IdReclamosInspeccion: ReclamosInspeccionNI.id,
            Origen: 1,
            TipoDocumento: typeFileEnum.signatureDriverImage,
            Archivos: lst
        } as IImageInspectionGeneral
        return http(endPoints.uploadFileInspection).post(data);
    }

    const UploadFile = async (propierties: string, files: Array<File> | undefined, type: typeFileEnum) => {
        let lst: Array<IImageInspectionDto> = [];
        let isModified: boolean = ReclamosInspeccionNI[propierties as keyof typeof ReclamosInspeccionNI];
        if (files !== undefined && files.length > 0 && isModified) {
            for (const element of files)
                lst.push(await compressFiles(element, `${nameFile[type]}_${getNewGuid(1)}`));

            const data: IImageInspectionGeneral = {
                IdReclamosInspeccion: ReclamosInspeccionNI.id,
                Origen: 1,
                TipoDocumento: type,
                Archivos: lst
            } as IImageInspectionGeneral
            return http(endPoints.uploadFileInspection).post(data);
        }
    }

    const UploadFileInspectionImage = async () => {
        const lst = getFilesInspection(ReclamosInspeccionNI);
        if (lst.length > 0) {
            const data: IImageInspectionGeneral = {
                IdReclamosInspeccion: ReclamosInspeccionNI.id,
                Origen: 1,
                TipoDocumento: typeFileEnum.inspectionImage,
                Archivos: lst
            } as IImageInspectionGeneral
            return http(endPoints.uploadFileInspection).post(data);
        }

    }

    const SaveDamage = async () => {
        const data = getVehicleDamageNIDTO(ReclamosInspeccionNI.lstVehicleDamage ?? []);
        if (data.length > 0) {
            return http(endPoints.saveDamageVehicleDamage(ReclamosInspeccionNI.id, '1')).post(data)
        }
    }

    const SaveDataVehicleInvolved = async () => {
        if (ReclamosInspeccionNI.isVehiclesInvolved === 'N') return;
        let data = await buildDataVehicleInvolved(ReclamosInspeccionNI.vehiclesInvolved ?? []);
        if (data.length > 0)
            return http(endPoints.saveVehiclesInvolved(ReclamosInspeccionNI.id, '1')).post(data)
    }

    const UploadFileToProcedure = () => http(endPoints.inspectionUploadFileToProcedure(ReclamosInspeccionNI.id)).get();
    const UploadFileToProcedureCheckList = () => http(endPoints.inspectionUploadFileToProcedureCheklist(ReclamosInspeccionNI.id)).get();


    const GetInformationInspection = () => {
        if (id === null || id === undefined || id === '') {
            loadingModal.hide();
            msgModal.setTextError('No se encontro registro');
            return;
        }

        loadingModal.show("Cargando datos...");

        http(endPoints.getInformationInspectionClaim(id))
            .get()
            .then((result: any) => {

                const dataInfo: IIformationIspection = JSON.parse(result.message);
                loadingModal.hide();

                setReclamosInspeccionNI({ ...ReclamosInspeccionNI, id: id });
                if (dataInfo.Estado === inspectionStatusEnum.cancelled.valueOf() || dataInfo.Estado === inspectionStatusEnum.finished.valueOf())
                    msgModal.setTextError('La inspeccion esta finalizada');

            }).catch((error: string) => {
                loadingModal.hide();
                msgModal.setTextError('No se encontro registro, contactar a Seguros LAFISE');
            })
    }

    const UpdateInspection = (status: inspectionStatusEnum) => {
        const data = buildDataUpdate(ReclamosInspeccionNI, index, status);
        return http(endPoints.updateRegistrationInspection).post(data);
    }

    const GetCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.permissions.query({ name: "geolocation" })
                .then(function (result) {
                    if (result.state === "granted") {
                        navigator.geolocation.getCurrentPosition(successLocation, errorLocation, options)
                    } else if (result.state === "prompt") {
                        navigator.geolocation.getCurrentPosition(successLocation, errorLocation, options)
                    } else if (result.state === "denied") {
                        //denegado
                    }
                });
        } else { console.log("Navegador no soportado"); }
    }


    const successLocation = (pos: any) => {
        let crd = pos.coords;
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, sinisterGPS: `${crd.latitude},${crd.longitude}`, sinisterLng: crd.longitude, sinisterLat: crd.latitude })
    }
    const errorLocation = (err: any) => console.warn(`ERROR(${err.code}): ${err.message}`);

    const ReloadPage = (e: any) => {
        if (ReclamosInspeccionNI.registration === 'S' && ReclamosInspeccionNI.saved === false) {
            e.preventDefault();
            e.returnValue = "";
        }
    }

    const GetInfoEnte = () => {
        loadingModal.show('Cargando información del asegurado...')
        http(endPoints.getEnteInspection(ReclamosInspeccionNI.id))
            .get()
            .then((x) => {
                let ente = JSON.parse(x.message);
                loadingModal.hide();
                setReclamosInspeccionNI({
                    ...ReclamosInspeccionNI,
                    insuredName: ente.NombreApellidoAsegurado,
                    insuredCellPhone: ente.Celular,
                    insuredMail: ente.Correo,
                    insuredAddress: ente.Direccion
                });
            })
            .catch(() => loadingModal.hide())
            .finally(() => Increment());
    }

    const Reload = (e: any) => {
        e.preventDefault();
        setModalErrorId(false)
        loadingModal.show();
        window.location.reload();
    }


    return (
        <div className="container">
            <div className="layout-reclamos-inspeccion-ni">
                <div className="mt-10">
                    <p className="lbl-title title-1">{siteTitle.title1}</p>
                    <p className="lbl-title title-2">{siteTitle.title2}</p>
                </div>
                <LineProgressBar index={infoPage.indexBar} totalPages={TotalPageBar} />
                <form>
                    <div style={{ display: "flex" }}>
                        <div className="step-container-ihcr">
                            <PagesTitleCtrl {...infoPage} />
                            <Pages {...infoPage} />
                        </div>
                    </div>
                    <ButtonCtrl data={infoPage} submit={Submit} back={Decrement} />
                </form>
            </div>
            {/* <ModalMsgCtrl {...modalLoading} closeModal={() => setModalLoading({ ...modalLoading, active: false, isloading: true })} /> */}
            <ModalMsgCtrl {...loadingModal.modal} closeModal={loadingModal.hide} />
            <ModalMsgCtrl {...msgModal.modal} closeModal={msgModal.hide} />
            <Modal isOpen={modalErrorId} className='modal'>
                <div className='pb-20 pt-20'>
                    <label style={{ textAlign: 'center', fontSize: '20px', color: '#FF0000', lineHeight: '30px', display: 'flex', justifyContent:'center' }}>¡Ha ocurrido un error!</label>
                    <div className='mt-40 mb-40' style={{display: 'flex', justifyContent:'center'}}>
                        < IconError />
                    </div>
                    <p style={{ textAlign: 'center', fontSize: '15px', color: '#4D4D4D', lineHeight: '22px' }}>
                            Se ha perdido la conexión. Por favor, recargue la página para intentar nuevamente.
                    </p>                   
                    <div style={{display: 'flex', justifyContent:'center'}} className='mt-30 mb-30'>
                        <button className='btn-auto-cr back-auto-cr' onClick={Reload} type="button">Cargar nuevamente</button>
                    </div>                  
                </div>
            </Modal>
        </div>

    )
}

export default Reclamos_Inspeccion;
